/* Delegation survives Shopify section reloads without duplicating listeners. */
if (!window.bsApprovedHomeBound) {
  window.bsApprovedHomeBound = true;
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-bs-rail]');
    if (!button) return;
    const root = button.closest('.bsa-root');
    const rail = document.getElementById(button.dataset.bsRail);
    if (!root || !rail || !root.contains(rail) || !rail.firstElementChild) return;
    const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
    rail.scrollBy({left: (rail.firstElementChild.getBoundingClientRect().width + gap) * Number(button.dataset.dir), behavior: 'instant'});
  });
}
